export default {
  data () {
    return {
      pending: undefined,
      error: undefined
    }
  },
  computed: {
    newEntity () {
      return !!this.pending && !this.pending.id
    }
  },
  methods: {
    emitInput (value) {
      this.error = undefined
      this.$emit('input', value)
    },
    emitCancel () {
      this.$emit('cancel')
    },
    editFailed (error) {
      this.error = error
    }
  }
}
